import {Component, Input, OnInit, OnDestroy, Renderer2} from '@angular/core';
import {LotteriesService} from '../../../lotteries.service';
import {Subscription} from 'rxjs';
import {SubscriptionsService} from '../../../_services/subscriptions.service';
import * as globals from '../../../settings';
import {UserService} from '../../../_services/user.service';
import {GameLauncherService} from '../../../_services/game-launcher.service';

@Component({
  selector: 'app-insta-games-home',
  templateUrl: './insta-games-home.component.html',
  styleUrls: ['./insta-games-home.component.scss']
})
export class InstaGamesHomeComponent implements OnInit, OnDestroy {
  featured: any;
  gameDis: Subscription;
  user: Subscription;
  gameDisabled: boolean;
  showtime: boolean;
  isLoggedIn: boolean;
  showSparkles: boolean[];
  showLang: any;
  languageChange: any;
  isMobile: any;
  userDetails: any[];
  preLoginGameId: any;
  preLoginGameBet: any;
  preLoginGameStatus: boolean;
  startedGameID: any;
  changedStartedGameID: Subscription;
  constructor(public lotteryService: LotteriesService, private subscriptionsService: SubscriptionsService,
              public userService: UserService,
              private renderer: Renderer2,
              private gameLauncher: GameLauncherService) {
    this.showSparkles = [];
    this.gameDisabled = false;
    this.showtime = false;
    this.gameDis = this.subscriptionsService.getGameDisable().subscribe(data => {
      this.gameDisabled = true;
    });
    this.languageChange = this.subscriptionsService.getLanguage().subscribe(lang => {
      this.showLang = lang;
    });
    this.user = this.subscriptionsService.getLoggedInStatus().subscribe(data => {
      if (data === true) {
        this.userDetails = this.userService.userData;
        if (this.userDetails) {
          if (this.preLoginGameStatus && !this.userService.step3) {
            this.runGame(this.preLoginGameId, this.preLoginGameBet);
          }
        }
      } else {
        this.isLoggedIn = false;
      }
    });

    this.lotteryService
      .getLotteries(globals.appDomain + '/InstantGames/getGameCategoriesWithPackages/instantGames.json')
      .subscribe(
        data => {
          data.forEach((elem) => {
            if (elem.Name === 'Homepage') {
              this.featured = elem.instantGames;
            }
          });
        }
      );
    this.changedStartedGameID = this.subscriptionsService.getTriggeredEndGameSessionIG().subscribe(data => {
      this.startedGameID = data;
    });
  }

  ngOnInit() {
    this.startedGameID = false;
    this.preLoginGameStatus = false;
    this.isLoggedIn = false;
    this.showLang = localStorage.getItem('pageLanguage');
    setTimeout(() => {
      this.showtime = true;
    }, 300);
  }

  ngOnDestroy() {
    if (this.gameDis) {
      this.gameDis.unsubscribe();
    }
    if (this.user) {
      this.user.unsubscribe();
    }
  }

  runGame(gameId, minBet, background?) {
    this.startedGameID = gameId;
    this.subscriptionsService.emitGameBackground(background);
    this.preLoginGameStatus = false;
    this.gameLauncher.runGame(gameId, minBet).then((val) => {
      if (val === 'noUser') {
        this.renderer.addClass(document.body, 'modal-open');
        this.subscriptionsService.emitFakeCart(true);
        this.preLoginGameId = gameId;
        this.preLoginGameBet = minBet;
        this.preLoginGameStatus = true;
        if (gameId) {
          this.subscriptionsService.emitCurrentGameId(gameId);
        } else {
          this.subscriptionsService.emitCurrentGameId('-1');
        }
      }
      if (val === 'startGame') {
        this.gameDisabled = true;
        this.subscriptionsService.emitHideInstantBanner(true);
      }
    });
  }

  showSparkl(arr) {
    this.showSparkles[arr] = true;
  }

  hideSparkl(arr) {
    this.showSparkles[arr] = false;
  }

}


